module.exports = __webpack_public_path__ + "img/账号.c180b1f5.svg";